<template>
  <section v-if="base64Image" :class="bemBlock">
    <p>
      {{ $msg('search.imagesearch.preview', 'search') }}
    </p>
    <button :class="[bemElement('close'), 'btn-close']" @click.stop="close">
      <span class="visually-hidden">{{ $msg('global.close', 'locale') }}</span>
    </button>
    <img :src="base64Image" alt="Image preview..." />
    <p>
      {{ $msg('search.imagesearch.results', 'search') }}
    </p>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { types } from '../store';
import bemClassesMixin from '../mixins/bemClassesMixin';

export default {
  name: 'BaseImageSearchPreview',
  mixins: [bemClassesMixin],
  computed: {
    ...mapState({
      base64Image: (state) => state.search.base64Image,
    }),
  },
  methods: {
    close() {
      this.$store.commit(types.search.setBase64Image, false);
    },
  },
};
</script>
